export default __webpack_public_path__ + "static/media/english-to-latvian-screenshot-05.4824bf35.png";